export default __webpack_public_path__ + "static/media/reward-actions.b7fd1471.svg";